import { render, staticRenderFns } from "./BottomControl.vue?vue&type=template&id=32369734&scoped=true&lang=pug&"
var script = {}
import style0 from "./BottomControl.vue?vue&type=style&index=0&id=32369734&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32369734",
  null
  
)

component.options.__file = "BottomControl.vue"
export default component.exports